import {
  SoccerEventDetailId,
  SoccerEventStatusId,
} from '@collector/sportsapi-client-legacy'

import {
  GetEventClockSeconds,
  GetEventClockTime,
  GetEventStatusPeriodLengthMinutes,
  IsValidEventClockTime,
  SECONDS_IN_MINUTE,
} from '../../configuration'

const eventStatusIdsSecondHalf: SoccerEventStatusId[] = [
  SoccerEventStatusId.Halftime,
  SoccerEventStatusId.SecondHalf,
  SoccerEventStatusId.FinishedRegularTime,
]

const eventStatusIdsFirstHalfExtratime: SoccerEventStatusId[] = [
  SoccerEventStatusId.WaitingForExtratime,
  SoccerEventStatusId.ExtratimeFirstHalf,
]

const eventStatusIdsSecondHalfExtratime: SoccerEventStatusId[] = [
  SoccerEventStatusId.ExtratimeHalftime,
  SoccerEventStatusId.ExtratimeSecondHalf,
  SoccerEventStatusId.FinishedAfterExtratime,
]

const eventStatusIdsPenaltyShootout: SoccerEventStatusId[] = [
  SoccerEventStatusId.WaitingForPenalty,
  SoccerEventStatusId.PenaltyShootout,
  SoccerEventStatusId.FinishedAfterPenalties,
]

export const getEventStatusPeriodLengthMinutes: GetEventStatusPeriodLengthMinutes =
  (eventStatusId, periodLength, extraPeriodLength, extraTimePlayed) => {
    if (
      eventStatusIdsSecondHalf.includes(eventStatusId as SoccerEventStatusId)
    ) {
      return periodLength
    }

    if (
      eventStatusIdsFirstHalfExtratime.includes(
        eventStatusId as SoccerEventStatusId,
      )
    ) {
      return periodLength * 2
    }

    if (
      eventStatusIdsSecondHalfExtratime.includes(
        eventStatusId as SoccerEventStatusId,
      )
    ) {
      return periodLength * 2 + extraPeriodLength
    }

    if (
      eventStatusIdsPenaltyShootout.includes(
        eventStatusId as SoccerEventStatusId,
      )
    ) {
      return extraTimePlayed
        ? periodLength * 2 + extraPeriodLength * 2
        : periodLength * 2
    }

    return null
  }

export const getEventClockSeconds: GetEventClockSeconds = (
  clockTime,
  periodLengthMinutes,
) => {
  return (periodLengthMinutes || 0) * SECONDS_IN_MINUTE + clockTime
}

export const isValidEventClockTime: IsValidEventClockTime = ({
  minute,
  periodLengthMinutes,
}) => {
  if (periodLengthMinutes === null) {
    return true
  }

  return minute >= periodLengthMinutes
}

export const getEventClockTime: GetEventClockTime = (
  minute,
  second,
  periodLengthMinutes,
) => {
  return (
    minute * SECONDS_IN_MINUTE +
    second -
    SECONDS_IN_MINUTE * (periodLengthMinutes || 0)
  )
}

export const extraTimeDetailId = SoccerEventDetailId.FirstExtraHalfStartDate
